export default "__VITE_ASSET__jejVjlYK__"